import { createContext } from 'react';

export const VisibilityContext = createContext<{
  toggleSeriesVisibility: (id: string) => void;
}>({
  toggleSeriesVisibility: () => {}
});
